import { WizardConfiguration as Admin } from './AdminWizardConfiguration';
import { WizardConfiguration as Learning } from './LearningWizardConfiguration';

export const WizardConfiguration = {
  Admin,
  Learning,
};
